// Бланки (ПН, пояснення, звіти) — HTML з власними <style> і атрибутами style="…". У iframe srcdoc, у вкладці з blob: і в
// about:blank документ успадковує CSP сторінки (style-src 'self'), тож браузер ці стилі блокує й бланк лишається без оформлення.
// CSP не забороняє CSSOM: вирізаємо стилі з розмітки, а після завантаження документа застосовуємо їх як сконструйовану таблицю
// (adoptedStyleSheets) і через element.style. Скрипти в бланках не потрібні й лишаються заблоковані
const STYLE_TAG = /<style\b[^>]*>([\s\S]*?)<\/style>/gi;
const STYLE_ATTR = /(<[a-zA-Z][^>]*?\s)style\s*=\s*("([^"]*)"|'([^']*)')/g;

export function splitStyles(html) {
  const css = [];
  let out = String(html || "").replace(STYLE_TAG, (_, body) => { css.push(body); return ""; });
  // Атрибут style → data-csp-style (значення те саме, лапки ті самі)
  out = out.replace(STYLE_ATTR, (_, head, quoted) => `${head}data-csp-style=${quoted}`);
  return { html: out, css: css.join("\n") };
}

export function applyStyles(doc, css) {
  if (!doc) return;
  const win = doc.defaultView;
  if (css && win?.CSSStyleSheet && "adoptedStyleSheets" in doc) {
    try { const sheet = new win.CSSStyleSheet(); sheet.replaceSync(css); doc.adoptedStyleSheets = [sheet]; } catch { /* старий браузер — без оформлення */ }
  }
  for (const el of doc.querySelectorAll("[data-csp-style]")) { el.style.cssText = el.getAttribute("data-csp-style"); el.removeAttribute("data-csp-style"); }
}

// Повний бланк у новій вкладці: about:blank того самого походження, розмітка без стилів + стилі через CSSOM
export function openStyled(html) {
  const { html: body, css } = splitStyles(html);
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.open(); w.document.write(body); w.document.close();
  applyStyles(w.document, css);
  w.opener = null;
  return true;
}
